export default "__VITE_ASSET__ulJ0X0kt__"